$(function () {
  // menu画面アニメーション
  $(".linkWrap").mouseover(function () {
    $(this).find(".linkItems").addClass("menuActive");
  });
  $(".linkWrap").on("mouseout", function () {
    $(this).find(".linkItems").removeClass("menuActive");
  });
  // ページ内スクロール
  $("a[href^='#']").click(function () {
    var target = $(this.hash);
    var position = $(target).offset().top;
    $("html,body").animate({ scrollTop: position }, 400);
    return false;
  });
  // アコーディオンパーツ
  $(function () {
    $(".s_01 .accordion_one .accordion_header").click(function () {
      $(this).next(".accordion_inner").slideToggle();
      $(this).toggleClass("open");
    });
  });
  // ページ内スクロール
  $(document).click(function (e) {
    if(!$(e.target).closest('.media-swiper-slide').length) {
      $(".media_pop").removeClass("media_pop_active")
    } else {
      $(".media_pop").addClass("media_pop_active")
    }
  });
  $(".media-swiper-slide").click(function (e) {
    $(".media_pop_img").removeClass("current_img")
    const clickImg = $(this).attr('id') + "-img";
    $('#' + clickImg).addClass("current_img")
  });
});
